import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconShieldCheckSvg } from './IconShieldCheckSvg';

export type IconShieldCheckProps = UseIconProps;

export function IconShieldCheck(props: IconShieldCheckProps) {
  const iconProps = useIcon(props);

  return <Box tagName={IconShieldCheckSvg} {...iconProps} />;
}
